$(document).ready(function(){

	// Artikel löschen
	$(".wako_del").click(function (){
		var form	= $(this).closest("form");
		var id		= $(this).attr("id").replace("wako_del_","");
		$("input[name=wako_anzahl_" + id +"]").val("0");
		$("button[name=wako_btn_submit_recalculate]").click();
	});

	// Zeige Wako-Overlay
	$(".wako-overlay-click").click(function(){
		update_wakobox();
		$("#warenkorb-overlay").show();
	});

	// Bestellung Details anzeigen
	$("span.bestellung-detail").click(function (){
		var id = $(this).attr("id").replace("bestellungen-detail-","");
		if ($("#wako_bestellungen_artikel_" + id).html() == '') {
			$("#wako_bestellungen_artikel_" + id).removeClass("display-none");
			$("#wako_bestellungen_artikel_" + id).addClass("display-block");
			$("#wako_bestellungen_artikel_" + id).html('<div class="bestellung_ajax_loader col-xs-12"><img src="/_images_global/ajax-loader-bestellungen.gif" alt="Bitte warten"/></div>');
			$("#details_oben_" + id).removeClass("display-block");
			$("#details_oben_" + id).addClass("display-none");
			$.ajax ({
				type: 'GET',
				url: '/warenkorb/ajax_bestellungen_details.html',
				data: 'bestellung_id=' + id,
				cache: false,
				success: function (html) {
					$("#wako_bestellungen_artikel_" + id).html(html);
					$("#details_unten_" + id).removeClass("display-none");
					$("#details_unten_" + id).addClass("display-block");
				}
			});
		}
	});

});

//Funktionen

//Add Article Funktion

function warenkorb_add(artikel_id,artikel_typ,id_popup) {
	$.ajax({
		type: 'GET'
		,url: '/warenkorb/ajax_add_artikel.html'
		,data: 'artikel_id=' + artikel_id + '&artikel_typ=' + artikel_typ
		,cache: false
		,success: function(xml,textStatus) {
			if ($('success', xml).text() == 'true') {
				// Find ALL Wako Counters
				window.parent.$('.wako_count').each(function() {
					if (window.parent.$(this).length > 0) {
						window.parent.$(this).html($('basket_count', xml).text());
					}
				});
				window.parent.update_wakobox();
				$("#" + id_popup).show();
			}
			else {
				alert("Artikel konnte nicht in den Warenkorb gelegt werden.");
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Artikel konnte nicht in den Warenkorb gelegt werden.");
		}
	});
}

//Delete Article Funktion

function warenkorb_delete(artikel_id,artikel_typ) {
	$.ajax({
		type: 'GET'
		,url: '/warenkorb/ajax_delete_artikel.html'
		,data: 'artikel_id=' + artikel_id + '&artikel_typ=' + artikel_typ
		,cache: false
		,success: function(xml,textStatus) {
			if ($('success', xml).text() == 'true') {
				// Find ALL Wako Counters
				window.parent.$('.wako_count').each(function() {
					if (window.parent.$(this).length > 0) {
						window.parent.$(this).html($('basket_count', xml).text());
					}
				});
				window.parent.update_wakobox();
			}
			else {
				alert("Der Artikel konnte nicht gelöscht werden.");
			}
		}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert("Der Artikel konnte nicht gelöscht werden.");
		}
	});
}

//Ajax Wako Update

function update_wakobox() {
	$.ajax({
		url: '/ajax/wako_overlay',
		type: "POST",
		success: function(html, textStatus){
			$(".warenkorb-overlay-content").replaceWith(html);
		},
		error: function(){
			alert("Beim Laden des Warenkorbs ist ein Fehler aufgetreten.")
		}
	});
}

//Toggle Lieferadresse

function toggle_lieferadresse() {
	if ($("input[name='rechnungsadresse_ist_lieferadresse']:checked").val() == '1') {
		$("#wako_form_lieferadresse").hide();
	} else {
		$("#wako_form_lieferadresse").show();
	}
}

//Toggle Wako Buttons

function toggle_wako_buttons(mobile_click,elem) {
	if (mobile_click === false) {
		var input_value		= $('input[name=titel_typ]:checked').val();
	} else {
		var input_value		= $('input[name=titel_typ_mobile]:checked').val();
	}
	if (input_value == 'h1') {
		$(".nebenprodukt_typ_1").hide();
		$(".nebenprodukt_typ_2").hide();
		$(".nebenprodukt_typ_3").hide();
		$(".haupt_produkt").show();
	} else if (input_value == 'n1') {
		$(".nebenprodukt_typ_1").show();
		$(".nebenprodukt_typ_2").hide();
		$(".nebenprodukt_typ_3").hide();
		$(".haupt_produkt").hide();
	} else if (input_value == 'n2') {
		$(".nebenprodukt_typ_1").hide();
		$(".nebenprodukt_typ_2").show();
		$(".nebenprodukt_typ_3").hide();
		$(".haupt_produkt").hide();
	} else if (input_value == 'n3') {
		$(".nebenprodukt_typ_1").hide();
		$(".nebenprodukt_typ_2").hide();
		$(".nebenprodukt_typ_3").show();
		$(".haupt_produkt").hide();
	}
}

function toggle_wako_buttons_liste(mobile_click,elem) {
	var box = $(elem).closest(".box");
	var ean = $(box).find('input[name^=titel_typ_]:checked').attr("name").match(/\d+/g);
	if (mobile_click === false) {
		var input_value		= $(box).find('input[name=titel_typ_'+ean+']:checked').val();
	} else {
		var input_value		= $(box).find('input[name^=titel_typ_mobile_]:checked').val();
	}
	if (input_value == 'h1') {
		$(box).find(".nebenprodukt_typ_1").hide();
		$(box).find(".nebenprodukt_typ_2").hide();
		$(box).find(".nebenprodukt_typ_3").hide();
		$(box).find(".haupt_produkt").show();
	} else if (input_value == 'n1') {
		$(box).find(".nebenprodukt_typ_1").show();
		$(box).find(".nebenprodukt_typ_2").hide();
		$(box).find(".nebenprodukt_typ_3").hide();
		$(box).find(".haupt_produkt").hide();
	} else if (input_value == 'n2') {
		$(box).find(".nebenprodukt_typ_1").hide();
		$(box).find(".nebenprodukt_typ_2").show();
		$(box).find(".nebenprodukt_typ_3").hide();
		$(box).find(".haupt_produkt").hide();
	} else if (input_value == 'n3') {
		$(box).find(".nebenprodukt_typ_1").hide();
		$(box).find(".nebenprodukt_typ_2").hide();
		$(box).find(".nebenprodukt_typ_3").show();
		$(box).find(".haupt_produkt").hide();
	}
}

//Toggle Lastschrift

function toggle_lastschrift() {
	if ($("input[name='wako_bezahltyp']:checked").val() == '3') {
		$("#wako_form_lastschrift").show();
	} else {
		$("#wako_form_lastschrift").hide();
	}
}

// Anzahl erneuern im Warenkorb

function recount(){
	$("button[name='wako_btn_submit_recalculate']").click();
}
